import ContentLoader from 'react-content-loader';
import styles from './index.module.scss';

type Props = {
  count: number;
};

export const SkeletonList: React.FC<Props> = ({ count }) => {
  return (
    <div className={styles.container}>
      {[...Array(count)].map((_, index) => (
        <div key={index} className={styles.skeletonContainer}>
          <ContentLoader uniqueKey={String(index)} speed={2} width={280} height={100}>
            <rect x="0" y="0" rx="2" ry="2" width="100" height="100" />
            <rect x="108" y="0" rx="2" ry="2" width="120" height="20" />
            <rect x="108" y="24" rx="2" ry="2" width="200" height="48" />
            <rect x="108" y="80" rx="2" ry="2" width="70" height="20" />
            <rect x="182" y="84" rx="2" ry="2" width="46" height="16" />
          </ContentLoader>
        </div>
      ))}
    </div>
  );
};
